import { render, staticRenderFns } from "./vue-good-wizard.vue?vue&type=template&id=ba81be10&scoped=true&"
import script from "./vue-good-wizard.vue?vue&type=script&lang=js&"
export * from "./vue-good-wizard.vue?vue&type=script&lang=js&"
import style0 from "./vue-good-wizard.vue?vue&type=style&index=0&id=ba81be10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba81be10",
  null
  
)

export default component.exports